import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material';

export const renderAuth = (value: boolean) =>
  value ? (
    <CheckCircleIcon sx={{ color: 'var(--green-color)' }} />
  ) : (
    <CancelIcon sx={{ color: 'var(--red-color)' }} />
  );
